module.exports = __webpack_public_path__ + "1ef8dbdf09783edfcdbf14a8b3bad39b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/jruby.png
// module id = 375
// module chunks = 1